import { pending, rejected, fulfilled } from '../async';
import { push } from 'react-router-redux';
import * as InitializePad from 'app/api/initialize-pad';
// import * as Pad from 'app/api/pad';
// import * as PadVisits from 'app/api/padVisits';
import dispatchError from 'app/redux/actions/error.action';
import { showErrorOverlay } from '../error-overlay.action';
import { showFeedbackSuccess } from 'app/redux/actions/initialize-pad/feedback.action';

export function padData(padId) {
  return dispatch => {
    dispatch(pending('INITIALIZE_PAD_CLIENT'));
    InitializePad.getPad(padId)
      .then(payload => {
        dispatch(fulfilled('INITIALIZE_PAD_CLIENT', payload));
      })
      .catch(err => {
        dispatchError(dispatch, err, true);
        dispatch(rejected('INITIALIZE_PAD_CLIENT', err));
      });
  };
}

export function padVisitData(padVisitId) {
  return dispatch => {
    dispatch(pending('INITIALIZE_PAD_COOPERATIVE'));
    InitializePad.getPadVisit(padVisitId)
      .then(payload => {
        dispatch(fulfilled('INITIALIZE_PAD_COOPERATIVE', payload));
      })
      .catch(err => {
        dispatchError(dispatch, err, true);
        dispatch(rejected('INITIALIZE_PAD_COOPERATIVE', err));
      });
  };
}

export function initializePadClient(padId, initializePadData) {
  return dispatch => {
    dispatch(pending('INITIALIZE_PAD_SUBMIT'));
    InitializePad.initializePadClient(padId, initializePadData)
      .then((/* payload */) => {
        dispatch(
          showFeedbackSuccess({
            title: `PAD iniciado com sucesso!`,
            show: true,
            success: true
          })
        );
        dispatch(fulfilled('INITIALIZE_PAD_SUBMIT'));
      })
      .catch(err => {
        dispatch(showErrorOverlay(err.errors));
        dispatch(rejected('INITIALIZE_PAD_SUBMIT'));
        dispatchError(dispatch, err, true);
      });
  };
}

export function initializePadCooperative(padVisitId, initializePadData) {
  return dispatch => {
    dispatch(pending('INITIALIZE_PAD_SUBMIT'));
    InitializePad.initializePadCooperative(padVisitId, initializePadData)
      .then((/* payload */) => {
        dispatch(
          showFeedbackSuccess({
            title: `Vinculação realizada com sucesso!`,
            show: true,
            success: true
          })
        );
        dispatch(fulfilled('INITIALIZE_PAD_SUBMIT'));
      })
      .catch(err => {
        dispatch(showErrorOverlay(err.errors));
        dispatch(rejected('INITIALIZE_PAD_SUBMIT'));
        dispatchError(dispatch, err, true);
      });
  };
}

export const selectAndUpdateData = data => ({
  payload: data,
  type: 'INITIALIZE_PAD_SELECT_AND_UPDATE_DATA'
});

export const updateSchedulePrescription = data => ({
  payload: data,
  type: 'INITIALIZE_PAD_UPDATE_SCHEDULE_PRESCRIPTION'
});

export const hospitalDischarge = dateTime => ({
  payload: dateTime,
  type: 'INITIALIZE_PAD_HOSPITAL_DISCHARGE'
});

export const dischargePatientPrevision = dateTime => ({
  payload: dateTime,
  type: 'INITIALIZE_PAD_DISCHARGE_PATIENT'
});

export const initializationSteps = data => ({
  payload: data,
  type: 'INITIALIZE_PAD_INITIALIZATION_STEPS'
});

export const changeRepetition = (repetition, padVisit) => ({
  payload: { repetition, padVisit },
  type: 'INITIALIZE_PAD_CHANGE_REPETITION'
});

// export const changeAutomaticRepeat = padVisit => ({
//   payload: padVisit,
//   type: 'INITIALIZE_PAD_AUTOMATIC_REPETITION'
// });

// export const changeDailyAutomaticRepeat = padVisit => ({
//   payload: padVisit,
//   type: 'INITIALIZE_PAD_DAILY_AUTOMATIC_REPETITION'
// });

export const updateScheduledMaximumVisits = data => ({
  payload: data,
  type: 'INITIALIZE_PAD_SCHEDULE_MAXIMUM_VISITS'
});

export const clearSchedule = padVisit => ({
  payload: padVisit,
  type: 'INITIALIZE_PAD_CLEAR_SCHEDULE'
});

export const changeDailyScheduleForm = (padVisit, dailyScheduleForm) => ({
  payload: { padVisit, dailyScheduleForm },
  type: 'INITIALIZE_PAD_DAILY_SCHEDULE_FORM_CHANGE'
});

export const changeDailyScheduleProfessinalName = ({ padVisit, code, professionalName }) => ({
  payload: { padVisit, code, professionalName },
  type: 'INITIALIZE_PAD_DAILY_SCHEDULE_PROFESSIONAL_NAME_CHANGE'
});

export const addDailyScheduleForm = padVisit => ({
  payload: padVisit,
  type: 'INITIALIZE_PAD_DAILY_SCHEDULE_FORM_ADD'
});

export const removeDailyScheduleForm = padVisit => ({
  payload: padVisit,
  type: 'INITIALIZE_PAD_DAILY_SCHEDULE_FORM_REMOVE'
});

export const reset = () => ({
  type: 'INITIALIZE_PAD_RESET'
});

export const redirectionPadMenu = () => {
  return push('/pad');
};

/**
 * Type of frequencies repetition.
 */
export const REPETITION = {
  NONE: 0,
  FOLLOW_FREQUENCY: 1,
  FREQUENCY_12X36: 2
};
